<template>
    <div class="incident-cards">
        <BusinessIncidentForm
            :errors="errors"
            :business-incident="businessIncident"
            :business-incident-activity-logs="businessIncidentActivityLogs"
            :business-incident-contracts="businessIncidentContracts"
            :business-incident-customer-requests="businessIncidentCustomerRequests"
            :business-incident-invoices="businessIncidentInvoices"
            :business-incident-orders="businessIncidentOrders"
            :business-incident-solutions="businessIncidentSolutions"
            :business-incident-tickets="businessIncidentTickets"
            :business-incident-types="businessIncidentTypes"
            :customer="customer"
            @submit-form="submitForm"
            @solve-incident="solveIncident"
            @cancel="cancel"
            @add-contracts="addContracts"
            @add-invoices="addInvoices"
            @add-orders="addOrders"
            @add-tickets="addTickets"
        />
    </div>
</template>

<script>
import App from '~@/App.vue'
import CustomerBase from '~@/Pages/Customers/Base'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import BusinessIncidentForm from '~@/Components/Customers/BusinessIncidents/Form'

export default {
    layout: [App, CustomerBase]
}
</script>

<script setup>

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    businessIncident: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => {
            return {}
        }
    },
    businessIncidentTypes: {
        type: Array,
        default: () => {
            return []
        }
    },
    businessIncidentCustomerRequests: {
        type: Array,
        default: () => {
            return []
        }
    },
    businessIncidentSolutions: {
        type: Array,
        default: () => {
            return []
        }
    },
    businessIncidentContracts: {
        type: Array,
        default () {
            return []
        }
    },
    businessIncidentInvoices: {
        type: Array,
        default () {
            return []
        }
    },
    businessIncidentOrders: {
        type: Array,
        default () {
            return []
        }
    },
    businessIncidentTickets: {
        type: Array,
        default () {
            return []
        }
    },
    businessIncidentActivityLogs: {
        type: Array,
        default () {
            return []
        }
    }
})

function submitForm (form) {
    form.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id })
    )
}

function solveIncident (form) {
    form.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id })
    )
}

function cancel () {
    router.get(route('customers.customers.business-incidents.index', { customer: props.customer.id }))
}

function addContracts ({ incidentForm, contractsForm }) {
    incidentForm.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id }),
        {
            onSuccess: () => {
                contractsForm.post(
                    route(
                        'customers.customers.add-business-incident-contract',
                        { businessIncident: props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addInvoices ({ incidentForm, invoicesForm }) {
    incidentForm.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id }),
        {
            onSuccess: () => {
                invoicesForm.post(
                    route(
                        'customers.customers.add-business-incident-invoice',
                        { businessIncident: props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addOrders ({ incidentForm, ordersForm }) {
    incidentForm.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id }),
        {
            onSuccess: () => {
                ordersForm.post(
                    route(
                        'customers.customers.add-business-incident-order',
                        { businessIncident: props.businessIncident.id }
                    )
                )
            }
        }
    )
}

function addTickets ({ incidentForm, ticketsForm }) {
    incidentForm.put(
        route('customers.customers.business-incidents.update', { customer: props.customer.id, business_incident: props.businessIncident.id }),
        {
            onSuccess: () => {
                ticketsForm.post(
                    route(
                        'customers.customers.add-business-incident-ticket',
                        { businessIncident: props.businessIncident.id }
                    )
                )
            }
        }
    )
}
</script>

<style lang="scss" scoped>
.incident-cards {
    display: grid;
    grid-gap: 15px;
}
</style>
